module.exports = __webpack_public_path__ + "media/bootstrap-icons/markdown-fill-1e00e29c.svg";